import * as Yup from "yup"
import { AcademicLevel, Email, FirstName, LastName, MobilePhone, Salutation, Consentement } from "services/validation"

// Le téléphone et les programmes ne sont pas obligatoires sur cette LP ; le campus l'est uniquement pour le PBM
const schema = Yup.object().shape({
  ...Consentement,
  rendezVous: Yup.string().required('Veuillez choisir un type de rendez-vous'),
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhone,
    ...Salutation,
    PGE__c: Yup.boolean(),
    BMI__c: Yup.boolean(),
    BBA__c: Yup.boolean(),
    PBM__c: Yup.boolean(),
    Campus__c: Yup.string().when('PBM__c', {
      is: true,
      then: (schema) => schema.required('Le campus est requis')
    })
  })
})

export default schema
